import blankCharacter from './Blank.json';
import sampleCharacter from './Sample_Character.json';

export const BLANK_CHARACTER = Object.freeze(blankCharacter);
export const SAMPLE_CHARACTER = Object.freeze(sampleCharacter);

export const fantasyNames = // random names
[
  "Vireth", "Lunir", "Sylka", "Dravo", "Elyra",
  "Fintar", "Gweva", "Haxen", "Iryna", "Jolth",
  "Kweva", "Lirax", "Mynor", "Nezra", "Ophir",
  "Prynn", "Quilo", "Rynne", "Sathir", "Tevra",
  "Uldin", "Vexis", "Wryna", "Xyler", "Yveth",
  "Zalir", "Aryth", "Blyro", "Cynna", "Drevo",
  "Elryn", "Fyxen", "Gryth", "Hynna", "Ildar",
  "Jynva", "Kryth", "Lunva", "Myrax", "Nythe",
  "Orynn", "Phexir", "Qwyn", "Rythe", "Sylir",
  "Tyven", "Uryth", "Vynna", "Wexar", "Xyren",
  "Zynar", "Alyva", "Breth", "Cyren", "Dwyn",
  "Eryth", "Fynva", "Glexar", "Hythe", "Iwyn",
  "Jexir", "Klyra", "Lyxen", "Mynva", "Nyxir",
  "Owyn", "Pyren", "Qryth", "Rynva", "Slythe",
  "Tyrax", "Uwyn", "Vryth", "Wynne", "Xynva",
  "Zryth", "Axyr", "Bwyn", "Clyth", "Dryn",
  "Ewyn", "Fryth", "Gwynne", "Hryth", "Ixyr",
  "Jynne", "Kwyn", "Lryth", "Mxyr", "Nynne",
  "Oxyr", "Pryth", "Qynne", "Rxyr", "Swyn",
  "Tryth", "Uxyr", "Vynne", "Wryth", "Xynne",
  "Zyren", "Peanut", "Gorgeous", "Savron",
  "Thogar", "Eljin",  "Kaelin", "Brynda", "Garrik",
  "Sorren", "Alric",  "Lirien", "Taland", "Varick",
  "Fenric", "Mirael", "Draven", "Kareth", "Zalnor",
  "Calric", "Nyvara", "Orland", "Selric", "Davian",
  "Ragnar", "Eowina", "Luthor", "Vaelis", "Trenna",
  "Malric", "Zeriah", "Torren", "Shaela", "Jareth",
  "Rowena", "Kelric", "Hadrin", "Sylvar", "Orimar",
  "Aramis", "Kaedor", "Darian", "Theren", "Vexira",
  "Lucian", "Raenor", "Merric", "Elowen", "Tiron",
  "Neriah", "Kaelis", "Jorund", "Brylen", "Seraph",
  "Corwin", "Emberl", "Lareth", "Velkan", "Korrin",
  "Dorian", "Sylric", "Kaelor", "Tarian", "Zanrik",
  "Elthor", "Myrrin", "Shaena", "Torvak", "Laneth",
  "Alvara", "Vorlen", "Kendry", "Drelan", "Maelis",
  "Renner", "Faelar", "Gareth", "Orrick", "Zenric",
  "Theris", "Arvyn",  "Mireya", "Valtor", "Karnis",
  "Selene", "Joziah", "Nymeri", "Weylin", "Zerros",
  "Lorcan", "Arwynn", "Branik", "Tyrael", "Kelven",
  "Rordan", "Evryn",  "Malric", "Sorien", "Trenor",
  "Nareen", "Tavian", "Ysolde", "Jorlan", "Cindel",
  "Aelrion", "Thandor", "Garrick", "Sylvian", "Bryneth",
  "Kaedric", "Drovian", "Melkara", "Torvane", "Zanther",
  "Elandor", "Nimriel", "Voramir", "Kelmorn", "Shaerra",
  "Orindel", "Vaelric", "Tavarin", "Myrrian", "Lucaris",
  "Drelgar", "Fenrith", "Haloran", "Corvane", "Joramir",
  "Malther", "Xandros", "Seridan", "Weylorn", "Zorvath",
  "Kandrel", "Elarion", "Trenrik", "Valther", "Aeridan",
  "Roderic", "Sylvara", "Caleron", "Delrith", "Morvian",
  "Varnell", "Kaelian", "Taneris", "Orrivan", "Ryvenor",
  "Nethral", "Alvaren", "Thavrik", "Korriah", "Meridar",
    "Arvenil", "Belmora", "Cedrion", "Dalmira", "Eronius",
  "Faelric", "Galvorn", "Haldran", "Ilvarin", "Jandros",
  "Kelvian", "Lazamir", "Moradin", "Neromar", "Olvaren",
  "Perevin", "Quelran", "Rhodric", "Selarin", "Talgrim",
  "Ulvaron", "Valmira", "Wenrick", "Xelrion", "Yorimar",
  "Zandros", "Aelward", "Barthon", "Corwain", "Druamir",
  "Elvaren", "Feramir", "Grelian", "Helvorn", "Ithriel",
  "Joramir", "Keldros", "Loramir", "Melgorn", "Norveth",
  "Orminar", "Paelric", "Qarnith", "Rhalgor", "Seldric",
  "Tarnell", "Ulbrien", "Vandrin", "Woramir", "Xandrin",
  "Yvarren", "Zelthor", "Aurenor", "Brandor", "Celmira",
  "Dravian", "Esmiron", "Farveth", "Gornath", "Hadriel",
  "Ivoneth", "Jarmine", "Korveth", "Lenmira", "Marikon",
  "Neldric", "Oranion", "Pelgrim", "Quenric", "Revonar",
  "Selthor", "Toramir", "Urvanor", "Veramil", "Wenlorn",
  "Xoramir", "Ytharin", "Zalvaren", "Ashamir", "Bravian",
  "Calmira", "Delvorn", "Eldross", "Frandor", "Glendil",
  "Harneth", "Icarian", "Jarvorn", "Karnell", "Liorian",
  "Morvain", "Naelric", "Othamir", "Parveth", "Quarien",
  "Renlorn", "Sarnell", "Tovarin", "Urelian", "Venomar",
  "Wylamir", "Xervian", "Yorrick", "Zelmaro", "Ambrion",
  "Bojangle", "Casvorn", "Doramir", "Elarith", "Falgren",
  "Garnith", "Heramir", "Ilmarin", "Jarenth", "Kelmira",
  "Luravin", "Marneth", "Noramir", "Osvarin", "Pelneth",
  "Quelmir", "Ralvorn", "Simrion", "Tanvarn", "Umbrial",
  "Voramir", "Wendric", "Xarilth", "Yulmaro", "Zorvian",
  "Andrion", "Brendil", "Carveth", "Duramir", "Esmarin",
  "Frorick", "Grelmir", "Harnick", "Ivriont", "Jelvorn",
  "Kavarin", "Leomarx", "Malvorn", "Narmiel", "Orvendr",
  "Palronn", "Queldin", "Rosamir", "Santhir", "Tarnick",
  "Urravin", "Vaelric", "Wilvorn", "Xenrith", "Yulmira",
  "Zarnick", "Anorian", "Balveth", "Celrond", "Duriont",
  "Evrador", "Fandril", "Garleth", "Hothmir", "Ismaril",
  "Jolvian", "Keldwin", "Lenovar", "Mordric", "Nolrion",
  "Orramir", "Pevonar", "Quarnis", "Redolin", "Sarvorn",
  "Telonar", "Ulmiran", "Vorneth", "Wyramir", "Xaldric",
  "Yernora", "Zelvorn", "Avarion", "Branthor", "Coramir",
  "Dalvorn", "Elronar", "Felgrim", "Gilamir", "Hurnoth",
  "Isvalin", "Junther", "Karnith", "Laevorn", "Morlith",

  "Benjar", "Biatix", "Cappy", "Cerix", "Drego",
  "Elstar", "Estra", "Fairlane", "Haggar", "Iolain",
  "Jaxper", "Jertak", "Kraxx", "Lorinian", "Morgra",
  "Nexon", "Norbert", "Osterax", "Pelinor", "Quissix",
  "Rastafar", "Regolain", "Sevilla", "Soreth", "Tregg",
  "Urburg", "Vacavian", "Wendell", "Xasper", "Yolindra",
  "Zeppo", "Greggo", "Aloric", "Grumjim", "Steve",
  "Casper", "Bilgrath", "Aspson", "Tooz", "Tater",

  "Alghemany", "Blonk", "Clem", "Diogenus", "Elspar",
  "Ferric", "Ganosh", "Haley", "Irvog", "Jocasta",
  "Katrix", "Lemmon", "Mostrakar", "Nigel", "Orvar",
  "Phellit", "Qrix", "Rainmaker", "Selaria", "Turbo",
  "Kecke", "Ulf", "Vestigia", "Wainberg", "Xelor",
  "Yr'Gath", "Zupricado", "Pumpkin", "Yoshi", "Penguin",

  "Meblin", "Gnarl", "Danny",
]
